// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get list user company GET /api/v1/user-company */
export async function userCompanyList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userCompanyListParams,
  options?: { [key: string]: any },
) {
  return request<API.UserCompanyListDto>('/api/v1/user-company', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
